// extracted by mini-css-extract-plugin
export default {"termsContainer":"PaymentTerms_termsContainer__3R3W-","termsContent":"PaymentTerms_termsContent__Qiuqx"};